/* eslint-disable import/prefer-default-export */

export const themeClass = (theme) => `theme_${theme}`;
